/** Layer 2: queryOptions factory for the localized enum catalog. */
import { queryOptions } from "@tanstack/react-query";
import i18n from "@/i18n";
import { getEnums } from "./enumsApi";
import { enumKeys } from "./queryKeys";

/**
 * Enums change rarely but are localized — the active language is part of the
 * cache key, so switching app language refetches the correctly-localized labels
 * instead of serving stale ones. 1h staleTime keeps refetches minimal.
 */
export const getEnumsQueryOptions = () =>
  queryOptions({
    queryKey: enumKeys.catalog(i18n.language),
    queryFn: getEnums,
    staleTime: 1000 * 60 * 60, // 1h — vocab is near-static within a session
    gcTime: 1000 * 60 * 60 * 2,
  });
